import { ToastService } from '@philips-internal/oswald-ui-components';
import { Placement, ToastLevel, ToastType } from '@philips-internal/oswald-ui-constants';
import { generateUUID } from '@philips-internal/oswald-ui-utils';

export function createAndShowToastMessage(
  message: string,
  level: ToastLevel,
  toastType: ToastType = ToastType.BUBBLE,
  highlight?: boolean,
  title?: string,
): void {
  ToastService.open({
    id: generateUUID(),
    title: title,
    message: message,
    showIcon: true,
    dismissible: false,
    highlight: highlight,
    level: level,
    type: toastType,
    placement: Placement.TOP,
    offset: 0,
  });
}
